module.exports = __webpack_public_path__ + "images/product-3.3cfddfa.jpg";